import React, {Component} from 'react';
import Popup from "../popups/Popup";
import {AJAX, close_popup, getEmailForMessages, setUrlSinglePageApp} from "../functions";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import moment from "moment";
import {withRouter} from "react-router";

class MessagePopup extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }
    closeModal() {
        this.props.closeModal()
    }
    render() {
        return (
            <Popup
                open={this.props.showModal}
                modal
                lockScroll
                closeOnDocumentClick={false}
                onClose={this.closeModal}
                className={"message-modal bm-modal"}
            >
                <>
                    <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="clearfix" />
                    <div className="col-12">
                        <div className="content" style={{postion: 'relative'}}>
                            <div className="title-section">Subject:</div>
                            <p>{this.props.message.subject}</p>
                            <div className="title-section">Text:</div>
                            <div className="t-msg">
                                <div dangerouslySetInnerHTML={{__html: this.props.message.text}} />
                                {
                                    this.props.message.link_attached_file ? (<>
                                            <div className="text-center">
                                                <div className="mb-2">
                                                    <a href={this.props.message.link_attached_file+'&download=1'}
                                                       className="blue-link">Download {this.props.message.type_attached_file === 'img' ? 'Image' : this.props.message.original_filename}</a>
                                                </div>
                                                {
                                                    this.props.message.type_attached_file === 'img' ? (
                                                            <img src={this.props.message.link_attached_file}/>
                                                    ) : ('')
                                                }
                                            </div>
                                        </>
                                     ) : ('')
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center mt-2">
                            <div className="go-btn go-back" onClick={this.closeModal}/>
                        </div>
                    </div>
                </>
            </Popup>
        )
    }
}

class MessagesPage extends Component {
    state = {
        currentPage: 1,
        totalPages: 1,
        totalMessages: 0,
        messages: [],
        showModal: false,
        message: {},
        email: ''
    };
    constructor(props) {
        super(props);
        this.state.email = getEmailForMessages();
        this.displayMessages = this.displayMessages.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.updateMessageStatus = this.updateMessageStatus.bind(this);
        this.nextPageMsgs = this.nextPageMsgs.bind(this);
        this.previousPageMsgs = this.previousPageMsgs.bind(this);
        this.updateCounter = this.updateCounter.bind(this);
        window.updateMessagesPage = this.getMessages = this.getMessages.bind(this);
        this.getMessages();

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentDidMount() {
    }

    getMessages(page=1) {
        let t = this;
        let params = {
            action: 'api/booking/get_messages',
            page: page,
            email: t.state.email
        };
        t.updateCounter();
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function(resp) {
                if (resp.success === 1 && Object.keys(resp.data).length > 0) {
                    t.setState(resp.data);
                }
                hidePreloader();
            },
            func_error: function (resp) {
                hidePreloader();
                close_popup();
                showPopupWithGoBack(resp.message);
            },
        })
    }

    updateCounter() {
        if (typeof window.getCountMessages ===  'function') {
            window.getCountMessages();
        }
    }

    hideMessage(id) {
        if (confirm('Are you sure you want to delete the message?'))
            this.updateMessageStatus(id, 'is_hidden');
    }

    nextPageMsgs() {
        let currPage = this.state.currentPage;
        if (this.state.totalPages <= currPage) {
            currPage = this.state.totalPages - 1;
        }
        this.getMessages(++currPage);
    }

    previousPageMsgs() {
        let currPage = this.state.currentPage;
        if (currPage < 2)
            currPage = 2;
        this.getMessages(--currPage);
    }

    openModal(item) {
        this.setState({message: item, showModal: true});
        this.updateMessageStatus(item.id,'is_shown')
    }

    updateMessageStatus(id, is) {
        let t = this;
        let params = {
            action: 'api/booking/update_message_status',
            page: t.state.currentPage,
            email: t.state.email,
            id: id,
            is: is
        };
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_callback: function(resp) {
                if (resp.success === 1 && Object.keys(resp.data).length > 0) {
                    t.setState(resp.data);
                    t.updateCounter();
                }
            },
            func_error: function (resp) {
                t.updateCounter();
                close_popup();
                showPopupWithGoBack(resp.message);
            },
        });
    }

    closeModal() {this.setState({showModal: false, message: {}})}

    displayMessages() {
        let fromFormatDate = 'YYYY-MM-DD HH:mm:ss';
        let toFormatDate = 'DD/MM/YYYY HH:mm:ss';
        return <>{
            this.state.messages && this.state.messages.length ? (
                this.state.messages.map((item) => {
                    return <div key={item.id} className="msg">
                        <div className="text" onClick={()=>{this.openModal(item)}} >
                            <div className="subject">
                                {
                                    item.is_shown == 0 ? <b>{item.subject}</b>
                                        : item.subject
                                }
                            </div>
                            <div className="time">{moment(item.created_at, fromFormatDate).format(toFormatDate)}
                                {
                                    item.link_attached_file ? (<>
                                            &nbsp;<i className="fa fa-paperclip" />
                                        </>) : ('')
                                }
                            </div>
                        </div>
                        <div className="action">
                            <div className="hide_message" onClick={()=>this.hideMessage(item.id)}/>
                        </div>
                    </div>
                })
            ) : (<p className="text-center">No Messages</p>)
        }</>
    }

    displayPagination() {
        if (this.state.totalPages > 1) {
            return (
                <div className="row mt-3">
                    <div className="col-12">
                        <div className="pagination-messages">
                            <div className="cell text-right">
                                {
                                    this.state.currentPage > 1 ? (
                                        <button type="button" className="go-btn go-back"
                                                onClick={this.previousPageMsgs}/>
                                    ) : ('')
                                }
                            </div>
                            <div className="cell text-center page-of">
                                Page {this.state.currentPage} of {this.state.totalPages}
                            </div>
                            <div className="cell text-left">
                                {
                                    this.state.currentPage < this.state.totalPages ? (
                                        <button type="button" className="go-btn go-next" onClick={this.nextPageMsgs}/>
                                    ) : ('')
                                }
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else return '';
    }

    render() {
        return (
            <>
                <div className={'value-space'}>
                    <div className="row">
                        <div className="offset-1 col-10">
                            <div className="row">
                                <div className="col-12 text-center my-4">
                                    <h1>Messages</h1>
                                    <span className="small-text">Click on the message to see the details</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="messages">
                                        {this.displayMessages()}
                                    </div>
                                </div>
                            </div>
                            {this.displayPagination()}
                        </div>
                    </div>
                </div>
                <MessagePopup message={this.state.message}
                              showModal={this.state.showModal}
                              closeModal={this.closeModal}
                />
            </>
        );
    }
}

const MessagesPageR = withRouter(MessagesPage);
export default MessagesPageR;